// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Custom URL Modal - Clean Design */

.custom-url-modal .ant-modal-body {
  padding: 24px 24px 32px;
}

/* Mode selector - card style */
.custom-url-mode-section {
  margin-bottom: 24px;
}

.custom-url-mode-label {
  font-size: 13px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 8px;
  display: block;
}

.custom-url-mode-label-desc {
  font-size: 12px;
  color: #6b7280;
  font-weight: 400;
  margin-bottom: 12px;
}

.custom-url-mode-options {
  display: flex;
  gap: 12px;
  margin-bottom: 12px;
}

.custom-url-mode-card {
  flex: 1 1;
  padding: 16px 20px;
  border: 2px solid #e5e7eb;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  background: #fafafa;
}

.custom-url-mode-card:hover {
  border-color: #93c5fd;
  background: #f8fafc;
}

.custom-url-mode-card.active {
  border-color: #042957;
  background: rgba(51, 122, 183, 0.04);
}

.custom-url-mode-card-title {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 4px;
}

.custom-url-mode-card-desc {
  font-size: 12px;
  color: #6b7280;
  line-height: 1.45;
}

.custom-url-mode-alert {
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 8px;
}

/* Form field styling */
.custom-url-field-group {
  margin-bottom: 16px;
}

.custom-url-field-group:last-child {
  margin-bottom: 0;
}

.custom-url-field-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.custom-url-field-label .anticon {
  color: #6b7280;
  font-size: 13px;
}

.custom-url-field-helper {
  font-size: 12px;
  color: #6b7280;
  margin-top: 6px;
  margin-bottom: 0;
  line-height: 1.4;
}

/* Panel - minimal overrides, preserve Ant Design spacing */
.custom-url-panel .ant-collapse-header {
  font-weight: 600 !important;
  font-size: 14px !important;
}

.custom-url-panel .ant-collapse-item {
  border-bottom: 1px solid #f0f0f0 !important;
}

.custom-url-panel .ant-collapse-item:last-child {
  border-bottom: none !important;
}

/* Step 1 campaign name */
.custom-url-campaign-name-group {
  margin-bottom: 0;
}

.custom-url-campaign-name-group .custom-url-field-helper {
  margin-top: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/CustomUrl/CustomUrl.css"],"names":[],"mappings":"AAAA,oCAAoC;;AAEpC;EACE,uBAAuB;AACzB;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,2DAA2D;AAC3D;EACE,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,8BAA8B;AAChC;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB","sourcesContent":["/* Custom URL Modal - Clean Design */\n\n.custom-url-modal .ant-modal-body {\n  padding: 24px 24px 32px;\n}\n\n/* Mode selector - card style */\n.custom-url-mode-section {\n  margin-bottom: 24px;\n}\n\n.custom-url-mode-label {\n  font-size: 13px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 8px;\n  display: block;\n}\n\n.custom-url-mode-label-desc {\n  font-size: 12px;\n  color: #6b7280;\n  font-weight: 400;\n  margin-bottom: 12px;\n}\n\n.custom-url-mode-options {\n  display: flex;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.custom-url-mode-card {\n  flex: 1;\n  padding: 16px 20px;\n  border: 2px solid #e5e7eb;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background: #fafafa;\n}\n\n.custom-url-mode-card:hover {\n  border-color: #93c5fd;\n  background: #f8fafc;\n}\n\n.custom-url-mode-card.active {\n  border-color: #042957;\n  background: rgba(51, 122, 183, 0.04);\n}\n\n.custom-url-mode-card-title {\n  font-size: 14px;\n  font-weight: 600;\n  color: #1f2937;\n  margin-bottom: 4px;\n}\n\n.custom-url-mode-card-desc {\n  font-size: 12px;\n  color: #6b7280;\n  line-height: 1.45;\n}\n\n.custom-url-mode-alert {\n  margin-top: 0;\n  margin-bottom: 0;\n  border-radius: 8px;\n}\n\n/* Form field styling */\n.custom-url-field-group {\n  margin-bottom: 16px;\n}\n\n.custom-url-field-group:last-child {\n  margin-bottom: 0;\n}\n\n.custom-url-field-label {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.custom-url-field-label .anticon {\n  color: #6b7280;\n  font-size: 13px;\n}\n\n.custom-url-field-helper {\n  font-size: 12px;\n  color: #6b7280;\n  margin-top: 6px;\n  margin-bottom: 0;\n  line-height: 1.4;\n}\n\n/* Panel - minimal overrides, preserve Ant Design spacing */\n.custom-url-panel .ant-collapse-header {\n  font-weight: 600 !important;\n  font-size: 14px !important;\n}\n\n.custom-url-panel .ant-collapse-item {\n  border-bottom: 1px solid #f0f0f0 !important;\n}\n\n.custom-url-panel .ant-collapse-item:last-child {\n  border-bottom: none !important;\n}\n\n/* Step 1 campaign name */\n.custom-url-campaign-name-group {\n  margin-bottom: 0;\n}\n\n.custom-url-campaign-name-group .custom-url-field-helper {\n  margin-top: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
